{
	"title": "Verklaringen beheren",
	"createDeclaration": "Verklaring aanmaken"
}
